import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0481e770"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "title" };
const _hoisted_2 = { class: "wrapper" };
import BalancesGraph from '@/components/organisms/main/trade/balances/BalancesGraph.vue';
import AssetsChart from '../trade/balances/AssetsChart.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        displayTitle: null
    },
    setup(__props) {
        const props = __props;
        const { format } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(props.displayTitle)), 1)
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createVNode(BalancesGraph)
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(AssetsChart)
                    ])
                ])
            ], 64));
        };
    }
});
